import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { DeudaDetalle, DeudaDetalleData } from '../interfaces/DeudaDetalle.interfaces';

@Injectable({
  providedIn: 'root'
})
export class PagosLineaService {


  private flag: string = "";
  private country: string = "";
  private headers!: HttpHeaders;
  public response: any;
  flagAmbiente: string = 'uy';
  constructor(private _httpClient: HttpClient,public datepipe: DatePipe,) {
    this.headers = new HttpHeaders();
    this.headers = this.headers.set('accept', '*'),
    this.headers = this.headers.set('Content-Type', 'application/json');
    this.headers = this.headers.set('Access-Control-Allow-Origin', '*');
    this.headers = this.headers.set('Access-Control-Allow-Methods', 'POST, GET, PUT, UPDATE, OPTIONS');
  }

  getFlag() {
    return this.flag.trim();
  }

  getTypeDocument(ambiente: string): Observable<any> {
    let headersDoc = new HttpHeaders();
    headersDoc = headersDoc.set('pais', ambiente);
    // const response = this._httpClient.post(`${environment.urlBase}/api/interface/gettipodocs`, { headers: headers });
    const response = this._httpClient.post(`${environment.urlMercadoPago}/api/Deuda/ConsultarTiposDocumentosWeb`,null, { headers: headersDoc });
    return response;
  }

  getTipoDocumento(ambiente: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Accept", "application/json, text/plain")
    headers = headers.set("Accept-Language", "es-US,es-419;q=0.9,es;q=0.8,en;q=0.7")
    headers = headers.set("Connection", "keep-alive")
    headers = headers.set("Content-Type", "application/json")
    headers = headers.set("DNT", "1")
    headers = headers.set("Origin", "https://somosemi.com")
    headers = headers.set("Referer", "https://somosemi.com/")
    headers = headers.set("Sec-Fetch-Dest", "empty")
    headers = headers.set("Sec-Fetch-Mode", "cors")
    headers = headers.set("Sec-Fetch-Site", "cross-site")
    headers = headers.set("User-Agent", "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/107.0.0.0 Safari/537.36")
    headers = headers.set("sec-ch-ua", "\"Google Chrome\";v=\"107\") \"Chromium\";v=\"107\") \"Not=A?Brand\";v=\"24\"")
    headers = headers.set("sec-ch-ua-mobile", "?0")
    headers = headers.set("sec-ch-ua-platform", "\"Windows\"")
    headers = headers.set("Cookie", "ARRAffinity=03416650a10d89f1c7aba9abcba2c389d9405ebcf49e7f031a3a4bd0dfe699ec; ARRAffinitySameSite=03416650a10d89f1c7aba9abcba2c389d9405ebcf49e7f031a3a4bd0dfe699ec")
    headers = headers.set("Ambiente", ambiente )

    const response = this._httpClient.post(`https://middleware.grupoemi.com:7080/Catalogo/ListaTipoDocumentos`, { headers: headers });
    return response;
    
  }

  getDeudaDetalle(body: any, ambiente: string): Observable<DeudaDetalleData> {
    this.headers = this.headers.set("Content-Type", "application/json"),
    this.headers = this.headers.set("pais", ambiente);
    this.response = this._httpClient.post<DeudaDetalleData>(`${environment.urlMercadoPago}api/Deuda/ConsultarDeudaUsuarioWeb`, body, { headers: this.headers });                                                                                                                                                                                                                                                                                                      
    return this.response;
  }



  Pagar(body: any, ambiente: string): Observable<any> {
    this.headers = this.headers.set("Accept", "application/json, text/plain")
    this.headers = this.headers.set("Cache-Control", "no-cache")
    this.headers = this.headers.set("Accept-Language", "es-US,es-419;q=0.9,es;q=0.8,en;q=0.7")
    this.headers = this.headers.set("Content-Type", "application/json")
    this.headers = this.headers.set("pais", ambiente);
    this.headers = this.headers.set("Authorization", environment.token_payment);
    this.response = this._httpClient.post<DeudaDetalle>(`${environment.urlMercadoPago}api/MercadoPagoCol/pasarelaPagoWebEmi`, JSON.stringify(body), { headers: this.headers });
    return this.response;
  }

  getInfoPreference(id: string, ambiente: string): Observable<any> {
    this.headers = this.headers.set("Accept", "application/json, text/plain");
    this.headers = this.headers.set("Content-Type", "application/json")
    this.headers = this.headers.set("pais", ambiente);
    this.response = this._httpClient.post<DeudaDetalle>(`${environment.urlMercadoPago}api/MercadoPagoCol/ConsultarEstadoMercadoPagoWeb`, JSON.stringify(id), {headers: this.headers} );
    return this.response;
  }

}
